module.exports = __webpack_public_path__ + "static/media/login.dafe035f.png";